import type { SuggestedPlayerItem } from "@/api/custom_types";

export const isPendingToBeListed = (player: SuggestedPlayerItem): boolean => {
	switch (player.state) {
		case "LISTED":
		case "EXPIRED":
		case "REJECTED":
		case "LISTING_FAILED":
		case "PENDING":
			return false;

		case "ACCEPTED":
		case "LISTING":
			return true;

		default:
			player satisfies never;
			return false;
	}
};

export const hasPendingToBeListed = (
	players: SuggestedPlayerItem[] | undefined,
): boolean => (players ?? []).some(isPendingToBeListed);
